import one from '@mailobj-browser/front/js/selectors/one.js'
import { elements } from '../styles.js'
import { handle } from './wrapper.js'

const handler = (input, wrapper) => {
  const pattern = /^#?([a-f0-9]{6})$/
  const selectColor = one(`.${elements.new_field_select}`, wrapper)
  const option = one('option', selectColor)
  const icon = one(`.${elements.icon}`, wrapper)

  if (input.value.length === 7) {
    if (pattern.test(input.value)) {
      option.setAttribute('value', `${input.value}`)
      option.textContent = input.value
      icon.style.setProperty('--ea_icon_fill', `${input.value}`)
      selectColor.style.setProperty('--ea_pattern_color_color', `${input.value}`)
    }
  } else {
    option.setAttribute('value', '')
    option.textContent = 'transparent'
    icon.style.setProperty('--ea_icon_fill', 'transparent')
    selectColor.style.setProperty('--ea_pattern_color_color', 'transparent')
  }
}

export default input => {
  handle(input, handler)
}